import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionService } from '../../_services/permission.service';
import { MenuItems } from '@components/sidebar/menuItems';

export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  icontype?: string;
  collapse?: string;
  isCollapsed?: boolean;
  isCollapsing?: any;
  permission?: string|string[];
  children?: RouteInfo[];
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  public menuItems: any[];
  public isCollapsed = true;
  protected isSidebarMiniActive = true;

  constructor(
    private router: Router,
    private permissionService: PermissionService
  ) {}

  ngOnInit(): void {
    this.menuItems = this.filterMenuItems(MenuItems);

    this.router.events.subscribe((event) => {
      this.isCollapsed = true;
    });
  }

  minimizeSidebar(): void {
    const sidenavToggle = document.getElementsByClassName('sidenav-toggler')[0];
    const body = document.getElementsByTagName('body')[0];

    this.isSidebarMiniActive = body.classList.contains('g-sidenav-pinned');

    if (this.isSidebarMiniActive === true) {
      body.classList.remove('g-sidenav-pinned');
      body.classList.add('g-sidenav-hidden');
      sidenavToggle.classList.remove('active');
      this.isSidebarMiniActive = false;
    } else {
      body.classList.add('g-sidenav-pinned');
      body.classList.remove('g-sidenav-hidden');
      sidenavToggle.classList.add('active');
      this.isSidebarMiniActive = true;
    }

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 350); 
  }

  onMouseLeaveSidenav(): void {
    if (!document.body.classList.contains('g-sidenav-pinned')) {
      document.body.classList.remove('g-sidenav-show');
    }
  }

  private filterMenuItems(items: RouteInfo[]): RouteInfo[] {
    return items.filter(item => {
      const hasPermission = this.hasPermission(item);

      if (item.children) {
        item.children = this.filterMenuItems(item.children);
      }

      return hasPermission;
    });
  }

  private hasPermission(item: RouteInfo): boolean {
    if (item.permission === undefined) {
      return true;
    }

    // If the user has any permission of the permissions array
    // Then he can view the menu Item
    if (Array.isArray(item.permission)) {
      for (const p of item.permission) {
        if (this.permissionService.hasPermission(p)) {
          return true;
        }
      }

      return false;
    }

    return this.permissionService.hasPermission(item.permission);
  }
}
